import TableCell from '@material-ui/core/TableCell';

import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'react-leaflet-markercluster/dist/styles.min.css';
import L from 'leaflet';

import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';
import { Box } from '@material-ui/core';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl,
    iconUrl,
    shadowUrl,
});

export default function MapRow({ row, classes, isTable = true }) {
    if (!(row?.value?.latitude || row?.value?.longitude)) return null;
    const tilesUrl = `/query/tile/1/{z}/{x}/{y}`;
    const position = [row.value.latitude, row.value.longitude];

    const nPointMarker = L.icon({
        iconUrl:
            'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="%233A6178"/></svg>',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: null,
        shadowUrl: null,
        shadowSize: null,
        shadowAnchor: null,
    });

    const map = (
        <MapContainer
            className={classes.map}
            center={position}
            zoom={7}
            minZoom={2}
            maxZoom={14}
            attributionControl={false}
        >
            <TileLayer noWrap url={tilesUrl} />
            <Marker icon={nPointMarker} position={position} />
        </MapContainer>
    );

    if (isTable) {
        return (
            <TableCell className={classes.title} colSpan={2} component="th" scope="row">
                {map}
            </TableCell>
        );
    }

    return <Box>{map}</Box>;
}
